'use strict';

export default function($stateProvider) {
    'ngInject';
    $stateProvider
        .state('common-images-center', {
            url: '/common-images-center',
            template: '<common-images-center></common-images-center>'
        });
}



// WEBPACK FOOTER //
// ./client/app/common-images-center/common-images-center.routes.js